<!--
/**
* @name: List.vue
* @description: 优惠活动列表页
* @author: 赵辛淋
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入活动ID" block clearable v-model="para.id"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入活动名称" block clearable v-model="para.activityName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择活动状态" clearable block v-model="para.activityStatus" :class="css.inputW">
          <k-option v-for="item in statusTempList" :key="item.value" :value="item.value" :label="item.label">{{ item.label
          }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onView({}, 0)">新建</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize"
      @page-change="onChangePageIndex" :page-sizes="[10, 15, 30, 50, 100]" @size-change="onChangePageSize"
      layout='total,prev,pager,next,sizes,jumper' />
    <!-- 强制结束区域 start -->
    <div class="popup_box">
      <k-popup bind="v-if" okText="确认" cancelText="取消" title="强制结束" :show.sync="isPopupTypeShow"
        @after-ok="onEnd">
        <div style="width: 300px;">
          <span>确定是否强制结束？结束后活动将立即下线！</span>
          <y-form titleAlign="right">
            <y-form-item title="原因:" required>
              <k-input placeholder="请输入强制结束原因，不超过20个字。" clearable v-model="endRes"
                v-validate="'required|maxLength(20)'" block maxlength="20"></k-input>
            </y-form-item>
          </y-form>
        </div>
      </k-popup>
    </div>
    <!-- 强制结束区域 end -->
  </y-view>
</template>

<script>
import {
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_PAGE,
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_ACTIVITYCANCEL,
  NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_ACTIVITYFORCECANCEL
} from "@/assets/modules/apiList";

const initPara = () => ({
  activityStatus: "",
  activityName: "",
  id: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      dataList: [],
      para: initPara(),
      statusTempList: [
        { value: "WAIT", label: "待开始" },
        { value: "ONGOING", label: "进行中" },
        { value: "END", label: "已结束" },
        { value: "CANCEL", label: "已作废" }
      ],
      total: 0,
      activityId: "",
      curId: "",
      isPopupTypeShow: false,
      endRes: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "活动ID",
          field: "id",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "活动名称",
          field: "activityName",
          style: {
            textAlign: "center",
          },
          customRender: (row) => (
            <a href="javascript:void(0)" onClick={() => this.onView(row, 1)}>{row.activityName}</a>
          )
        },
        {
          name: "门店范围",
          field: "shopScopeType",
          style: {
            textAlign: "center",
          },
          customRender: (row) => (
            <div>{row.shopScopeType == "ALL" ? "全部门店" : row.shopScopeType == 'SPECIFIC' ? '指定门店参与' : '指定门店不参与'}</div>
          )
        },
        {
          name: "活动时间",
          field: "",
          style: { textAlign: "center", width: 250 },
          customRender: (row) => {
            return (
              <div>
                {row.startTime}~{row.endTime}
              </div>
            );
          },
        },
        {
          name: "状态",
          filed: "activityStatusName",
          style: {
            textAlign: "center"
          },
          customRender: (row) => {
            return (
              <div>
                {row.activityStatusName}
              </div>
            );
          },
        },
        {
          name: "创建时间",
          filed: "createTime",
          style: {
            textAlign: "center"
          },
          customRender: (row) => {
            return (
              <div>
                {row.createTime}
              </div>
            );
          },
        },
        {
          name: "操作",
          field: "action",
          style: { width: 180, textAlign: "center" },
          customRender: (row) => {
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row, 1);
                }}
              >
                查看
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row, 2);
                }}
              >
                编辑
              </a>
            );
            const cancelButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onCancel(row.id);
                }}
              >
                作废
              </a>
            );
            const endButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEndPop(row.id);
                }}
              >
                强制结束
              </a>
            );
            if (row.activityStatus == "WAIT") {
              return (
                <div>
                  {previewButton}&#12288;{editButton}&#12288;{cancelButton}&#12288;
                </div>
              );
            }
            if (row.activityStatus == "ONGOING") {
              return (
                <div>
                  {previewButton}&#12288;{editButton}&#12288;{endButton}
                </div>
              );
            }
            if (row.activityStatus == "END") {
              return (
                <div>
                  {previewButton}
                </div>
              );
            }
            if (row.activityStatus == "CANCEL") {
              return (
                <div>
                  {previewButton}
                </div>
              );
            }
          },
        },
      ];
    },
    //0.新建 1.查看 2.编辑
    onView(row, showType) {
      this.$controller.open({
        name: "preferentialAdd",
        query: {
          refresh: new Date() - 0,
          id: row.id || '',
          showType
        },
        title: showType == 0 ? "新增优惠活动" : showType == 1 ? "查看优惠活动" : "编辑优惠活动",
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getActivityList();
    },
    onReset() {
      this.para = initPara();
      this.getActivityList();
    },
    onChangePageSize(val) {
      this.para.pageSize = val;
      this.getActivityList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getActivityList();
    },
    getActivityList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_PAGE,
        para
      }).then((res) => {
        this.dataList = res.pageList;
        this.total = res.total;
      });
    },
    //作废
    onCancel(id) {
      let { tip } = this.$root;
      this.$dialog({
        title: "作废",
        content: "确定是否作废？作废后活动需重新创建！",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_ACTIVITYCANCEL,
            para: { id }
          })
            .then((res) => {
              this.isLoading = false;
              tip('作废成功！', 'success');
              this.getActivityList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    //强制结束
    onEndPop(id) {
      this.curId = id;
      this.endRes = '';
      this.isPopupTypeShow = true;
    },
    onEnd() {
      let { tip } = this.$root;
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_PROMOTIONAL_ACTIVITY_ACTIVITYFORCECANCEL,
        para: { id: this.curId, cancelReason: this.endRes }
      }).then((res) => {
        this.isLoading = false;
        this.isPopupTypeShow = false;
        tip('强制结束成功！', 'success');
        this.getActivityList();
      }).catch(() => {
        this.isLoading = false;
      });
    }
  },
  async created() {
    this.getActivityList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getActivityList();
    next();
  },
};
</script>

<style lang="postcss" module="css">
.statusStyle {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}

.box {
  position: relative;

  &>.tip {
    position: absolute;
    width: 246px;
    left: -50px;
    top: -45px;
    padding: 10px 15px;
    line-height: 20px;
    background-color: #5b5858;
    color: #fff;
    border-radius: 10px;
    display: none;
    z-index: 10000000000;

    &::after {
      position: absolute;
      content: " ";
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid #5b5858;
      left: 50%;
      top: 100%;
      transform: translateX(-50%);
    }
  }
}

.box:hover {
  cursor: pointer;
}

.box:hover .tip {
  display: block;
}

.textarea {
  width: 400px !important;
  height: 200px;

  & :global(.k-textarea) {
    height: 200px !important;
    resize: none;
  }
}

.inputW {
  width: 230px !important;
}
</style>
